import React from 'react';
import { getBusinessDetail } from "../../api/ClientApi";
import './style.css';
export default class Termcomponent extends React.Component {

    state = {
        business: null,
        loading: true
    };

    componentDidMount() {
        const secret_key = process.env.REACT_APP_SECRET_KEY;
        // 👇 get id from router state
        const id = this.props.businessId;
        if (id) {
           
            getBusinessDetail(secret_key, id)
                .then((data) => {
                   // alert('success');
                    this.setState({
                        business: data,
                        loading: false
                    });
                })
                .catch(() => {
                       //alert('catch');
                    this.setState({ loading: false });
                   
                });
        }
    }

    render() {

        if (this.state.loading) {
            return <div style={{ textAlign: "center" }}>Loading...</div>;
        }

        const business = this.state.business;
        const baseUrl = process.env.REACT_APP_API_URL;


        return (
          <section className="terms-section py-5">
    <div className="container">
        <div className="card shadow-lg border-0 rounded-4 p-4">

        <div className="row align-items-center">

            {/* LEFT SIDE IMAGE */}
            <div className="col-md-5 text-center mb-4 mb-md-0">
            <img
                className="img-fluid rounded-4 shadow-sm business-img"
                src={`${baseUrl}bussinesslogo/logo/${business?.logo || 'place-v1-img2.jpg'}`}
                alt="Business Logo"
            />
            </div>

            {/* RIGHT SIDE CONTENT */}
            <div className="col-md-7">
            {business && (
                <div className="business-content">

                {/* BUSINESS TITLE */}
                <h2 className="fw-bold mb-3">{business?.name}</h2>

                {/* DESCRIPTION */}
                <p className="text-muted mb-3">
                    {business?.description}
                </p>

                {/* BUSINESS INFO */}
                <div className="mb-2">
                    <strong>Category:</strong> {business?.category?.title || 'N/A'}
                </div>

                <div className="mb-2">
                    <strong>State:</strong> {business?.statedetail?.name || 'N/A'}
                </div>

                <div className="mb-2">
                    <strong>Country:</strong> {business?.countrydetail?.name || 'N/A'}
                </div>

                {/* OWNER DETAILS */}
                <hr className="my-3" />
                <h5 className="fw-bold">Owner Details</h5>

                <div className="mb-2 mt-2">
                    <strong>Name:</strong> 
                     {`${business?.ownerprofile?.fname || ''} ${business?.ownerprofile?.lname || ''}`.trim() || 'N/A'}
                </div>

                <div className="mb-2">
                    <strong>Email:</strong> {business?.ownerprofile?.email || 'N/A'}
                </div>

                <div className="mb-2">
                    <strong>Phone:</strong> {business?.ownerprofile?.phone || 'N/A'}
                </div>

                <div className="mb-2">
                        <strong>Gender:</strong>{" "}
                        <span className="text-capitalize">
                        {business?.ownerprofile?.gender || 'N/A'}
                        </span>
                    </div>


                    <div className="mb-2">
                        <strong>Address:</strong> {business?.ownerprofile?.address || 'N/A'}
                    </div>
                    
                </div>
            )}
            </div>

        </div>

        </div>
    </div>
    </section>
        );
    }
}